module["exports"] = [
  "#{street_root}#{street_suffix}",
  "#{street_prefix} #{street_root}#{street_suffix}",
  "#{Name.first_name}#{common_street_suffix}",
  "#{Name.last_name}#{common_street_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/street_name.js
// module id = 2729
// module chunks = 2